import { IModuleProps } from '../../core/utils/modules.tsx';

import routes from './routes.tsx';

export default {
    name: 'voice_agents',
    routes,
} as IModuleProps;
